import * as types from '../constants/ActionTypes'

const phonemidia = (state = [], action) => {
    switch (action.type) {
      case 'PHONEMIDIA':
        return action.phonemidia.map(phonemidia => {
          return phonemidia
        })
      default:
        return state
    }
  }
  
  export default phonemidia